import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { MaxBrainNavigationItemComponent } from './item.component';

@NgModule({
    imports: [MaxBrainSharedModule, MatIconModule],
    declarations: [MaxBrainNavigationItemComponent],
    exports: [MaxBrainNavigationItemComponent],
})
export class MaxBrainNavigationItemModule {}
